import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from "@tanstack/react-query";
import type { SetActiveGroupRequest } from "@/src/models/group";
import { getGroupContext, setActiveGroup } from "@/src/requests/group";
export const GROUP_CONTEXT_QUERY_KEY = ["group-context"];
export function useGroupContext(stytchOrgId) {
  const $ = _c(5);
  let t0;
  if ($[0] !== stytchOrgId) {
    t0 = [...GROUP_CONTEXT_QUERY_KEY, stytchOrgId];
    $[0] = stytchOrgId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = Boolean(stytchOrgId);
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: getGroupContext,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}
export function useSetActiveGroup() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
function _temp(request) {
  return setActiveGroup(request);
}